<template>
  <div class="card-wrapper" :class="{ feet: isFeet, 'mobile-scan': isMobileScan }" @click="onClick">
    <div class="relative avatar flex justify-center items-center">
      <img
        v-if="recordSnapshot"
        v-show="snapshotLoaded"
        class="snapshot placeholder"
        @load="onLoadend"
        @error="ready"
        :src="isFeet ? recordSnapshot : placeholderSrc"
        alt="3d avatar"
      />
      <img
        v-show="!snapshotLoaded"
        class="snapshot placeholder"
        :src="placeholderSrc"
        alt="3d avatar"
      />
      <div v-if="isMobileScanNotSuccessful" class="status-wrapper" :class="{ error: failed }">
        <img v-if="failed" src="@/assets/MobileScan/confused.svg" :alt="statusText" />
        <img v-if="processing" src="@/assets/MobileScan/scan-processing.svg" :alt="statusText" />
        {{ statusText }}
      </div>
    </div>
    <div class="detail">
      <div
        class="flex items-center font-semibold mb-2 md:text-3xl md:mb-4"
        style="white-space: nowrap;"
      >
        {{ cardLabel }}
        <div v-if="isBody" class="body-provider" :class="{ 'mobile-scan': isMobileScan }">
          <p>{{ providerText }}</p>
        </div>
      </div>
      <div class="flex justify-between">
        <div v-if="record.updated_at" class="time text-xs md:text-sm">
          {{ formatDate(record.updated_at) }}
        </div>
        <div class="text-xs md:text-sm">{{ $t('homePage.see_more') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { FEET_KIND } from '@/store/modules/user';
import DateTimeFormatter from '@/mixins/date-time-formatter';
import bodyPlaceholder from '@/assets/DefaultCloudzet/HomePage/3d-avatar.png';
import feetPlaceholder from '@/assets/FootScan/3d-feet.svg';
import { mapState } from 'vuex';

export default {
  name: 'MeasurementCard',
  mixins: [DateTimeFormatter],
  props: {
    record: Object,
    isMobileScan: Boolean,
  },
  mounted() {
    if (!this.recordSnapshot) {
      this.ready();
    }
  },
  data: () => ({
    snapshotLoaded: false,
  }),
  methods: {
    onLoadend() {
      this.snapshotLoaded = true;
      this.ready();
    },
    onClick() {
      this.$emit('click', this.record);
    },
    ready() {
      this.$emit('ready');
    },
  },
  computed: {
    ...mapState('user', ['isPollingMobileScan']),
    providerText() {
      return this.record.provider
        ? this.$t('mobileScan.mobile_scan')
        : this.$t('mobileScan.body_scanner');
    },
    status() {
      return this.record.status;
    },
    processing() {
      return this.status === 0 || this.isPollingMobileScan;
    },
    failed() {
      return this.status === 4;
    },
    isMobileScanNotSuccessful() {
      return this.isPollingMobileScan || (typeof this.status !== 'undefined' && this.status !== 3);
    },
    statusText() {
      if (this.processing) return this.$t('mobileScan.data_processing');

      if (this.failed) return this.$t('mobileScan.data_process_failed');

      return '';
    },
    isBody() {
      return !this.record.kind;
    },
    isFeet() {
      return this.record.kind === FEET_KIND;
    },
    cardLabel() {
      return this.isFeet ? this.$t('footscan.feet_3d') : this.$t('homePage.body_3d_avatar');
    },
    placeholderSrc() {
      if (this.isFeet) return feetPlaceholder;

      return bodyPlaceholder;
    },
    recordSnapshot() {
      return this.record.icon_url || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  @apply flex flex-col h-full w-full;
  align-self: center;
}

.avatar {
  @apply h-full;
  background: linear-gradient(146.01deg, #c1bdce -17.46%, #ffffff 64.21%);
}

.snapshot {
  height: 90%;
  &.placeholder {
    @apply absolute mx-auto my-auto;
    height: 100%;
    object-fit: cover;
    object-position: bottom;
  }
}

.status-wrapper {
  @apply absolute flex items-center;
  img {
    @apply mr-2;
  }
  color: rgba(129, 70, 255, 1);
  font-size: 12px;
  top: 8px;
  left: 14px;
  &.error {
    color: #d12c2d;
  }
}

.body-provider {
  @apply ml-3 inline-flex font-bold text-xxs px-2;
  min-height: 18px;
  background: rgba(237, 239, 255, 0.8);
  border-radius: 12px;
  align-items: center;
}
.body-provider p {
  background: linear-gradient(270deg, #2245ff 0.85%, #4300d9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
.detail {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(250, 250, 250, 0.4);
  backdrop-filter: blur(2.5px);
  padding: 12px 15px 13px 24px;

  @screen md {
    padding: -1px 51px 33px 48px;
  }
}

.time {
  color: #979797;
}
</style>
